import { forwardRef } from 'react';
import Markdown from 'react-markdown';
import rehypeExternalLinks from 'rehype-external-links';
import { cn } from '@anytag/shared-utils';
import { MessageType } from './types';

export interface MarkdownReaderProps {
  className?: string;
  value?: MessageType['text'];
}

export const MarkdownReader = forwardRef<HTMLDivElement, MarkdownReaderProps>(({ value, className }, ref) =>
  value ? (
    <div className={cn(styles.wrapper, 'marker:', className)} ref={ref}>
      <Markdown
        children={value}
        components={{ pre: 'div' as 'pre' }}
        // https://github.com/remarkjs/react-markdown/blob/main/changelog.md#remove-linktarget
        rehypePlugins={[[rehypeExternalLinks, { target: '_blank', rel: 'noopener noreferrer' }]]}
      />
    </div>
  ) : null
);
MarkdownReader.displayName = 'MarkdownReader';

const styles = {
  // Custom html tags to let match with chatbox styles
  wrapper: cn(
    '[&_p]:text-lg',
    '[&_pre]:m-0',
    '[&_strong]:font-bold',
    '[&_hr]:h-[1px] [&_hr]:bg-[var(--textColor)]',
    '[&_a]:inline [&_a]:text-active [&_a]:hover:underline',
    '[&_ol]:whitespace-normal [&_ul]:whitespace-normal',
    '[&_h1]:text-revert [&_h2]:text-revert [&_h3]:text-revert [&_h4]:text-revert [&_h5]:text-revert [&_h6]:text-revert',
    '[&_li]:list-inside [&_li]:list-none [&_li]:text-lg [&_li]:marker:mr-1 [&_li_p]:inline',
    '[&_code]:box-border [&_code]:block [&_code]:rounded-sm [&_code]:border [&_code]:border-[var(--textColor)] [&_code]:p-2 [&_code]:break-words [&_code]:whitespace-pre-line'
  )
};
